import styled from 'styled-components';
import { setStepAndStore } from '../../../utils/profileAssistantState';

const Button = styled.button`
  margin-top: 12px;
  padding: 4px 12px;
  background: #00aef7;
  color: white;
  border: none;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease;

  &:hover {
    background: #0098d8;
  }
`;

const ExplainCustomerFocusStep = ({ profile, updateProfile, stepSetter }) => {

const handleBusinessFocusSelect = async (focus) => {
  try {
    console.log('🔍 DEBUG: Starting business focus selection', {
      focus,
      userId: profile?.u_id,
      businessId: profile?.b_id
    });

    const payload = {
      userId: profile?.u_id,
      businessId: profile?.b_id,
      customerFocus: focus,
      userFocus: focus === 'B2BC' ? null : focus
    };

    console.log('🔍 DEBUG: Sending payload to /api/onboarding/customer-focus:', payload);

    const response = await fetch(`/api/onboarding/customer-focus`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });

    console.log('🔍 DEBUG: API response status:', response.status);

    if (!response.ok) {
      const errorText = await response.text();
      console.error('🔍 DEBUG: API error:', errorText);
      throw new Error(`Failed to update customer focus: ${response.status} - ${errorText}`);
    }

    const updatedProfile = await response.json();
    console.log('🔍 DEBUG: API response data:', updatedProfile);

    // Check if user focus was actually set in the response
    console.log('🔍 DEBUG: User focus in response:', updatedProfile.u_customer_focus);

    // Update Zustand store
    updateProfile({
      b_customer_focus: focus,
      u_customer_focus: focus === 'B2BC' ? profile?.u_customer_focus : focus,
      business: {
        ...profile.business,
        b_customer_focus: focus
      }
    });

    // ✅ Advance to the next onboarding step based on server response
    stepSetter(updatedProfile.nextStep);

    
  } catch (err) {
    console.error('❌ Error updating business focus:', err.message);
  }
};

  return (
    <>
      <div style={{ whiteSpace: 'pre-line', marginBottom: '16px' }}>
        {`Hello ${profile?.u_first_name} ${profile?.u_last_name}. We are happy that you decided to join us. Now, ${profile?.u_first_name}, I need to ask you a few questions. The first one is about your company — the actual business itself.\n\nDoes your company do business with:`}
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: '2px', marginTop: '4px' }}>
        <Button onClick={() => handleBusinessFocusSelect('B2B')}>Businesses only</Button>
        <Button onClick={() => handleBusinessFocusSelect('B2C')}>Consumers only</Button>
        <Button onClick={() => handleBusinessFocusSelect('B2BC')}>Both Businesses and Consumers</Button>
      </div>
    </>
  );

};

export default ExplainCustomerFocusStep;